import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function TagStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M17.6484 7C17.6484 6.64102 17.3569 6.34961 16.998 6.34961C16.639 6.34961 16.3476 6.64102 16.3476 7C16.3476 7.35898 16.639 7.65039 16.998 7.65039C17.3569 7.65039 17.6484 7.35898 17.6484 7ZM19.3476 7C19.3476 8.29788 18.2958 9.34961 16.998 9.34961C15.7001 9.34961 14.6484 8.29788 14.6484 7C14.6484 5.70212 15.7001 4.65039 16.998 4.65039C18.2958 4.65039 19.3476 5.70212 19.3476 7Z"
				fill="currentColor"
			/>
			<path
				d="M21.1497 2.84961H12.8284C12.5235 2.84961 12.2306 2.97084 12.0149 3.18652L4.01493 11.1865C3.56585 11.6356 3.56585 12.3644 4.01493 12.8135L11.1868 19.9844C11.6359 20.4334 12.3637 20.4334 12.8128 19.9844L20.8128 11.9844C21.0284 11.7687 21.1496 11.4767 21.1497 11.1719V2.84961ZM22.8499 11.1719C22.8498 11.9276 22.5494 12.6521 22.0149 13.1865L14.0149 21.1865C12.902 22.2995 11.0976 22.2995 9.98465 21.1865L2.81278 14.0156C1.69979 12.9027 1.69977 11.0973 2.81278 9.98438L10.8128 1.98438C11.3473 1.44991 12.0726 1.15039 12.8284 1.15039H22.0003C22.4696 1.15055 22.8499 1.53066 22.8499 2V11.1719Z"
				fill="currentColor"
			/>
		</svg>
	);
}

TagStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default TagStrokeIcon;
